export const ALERT_SETTINGS = {
    position: 'bottom-left'
};

export const EMAIL_ADDRESS = 'info@eventeeko.sk';
